module.exports = __webpack_public_path__ + "static/img/KOBE-SHIPP.9d91a37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KOBE-SHIPP.jpg
// module id = Hy8L
// module chunks = 0